import moment from "moment/moment";

export const getFormattedTime = (date) => {
    return moment(date).format('LT');
}

export const urlParams = new URLSearchParams(window.location.search);